<div class="order-totals" [class.order-totals--card]="variant === 'card'">
    <div class="order-totals__row">
        <span class="text-black">{{ subtotalLabel }}</span>
        <span class="font-normal text-black">{{ subtotal | formatPrice }}</span>
    </div>

    <div class="order-totals__row" *ngIf="hasDiscount">
        <span class="text-black">{{ discountLabel }}</span>
        <span class="font-normal text-black">{{ discountAmount | formatPrice }}</span>
    </div>

    <div class="order-totals__row">
        <span class="text-black">{{ shippingLabel }}</span>
        <span class="font-normal text-black">{{ shippingAmount != null ? (shippingAmount | formatPrice) : shippingValue }}</span>
    </div>

    <div class="order-totals__row" *ngIf="showProcessingFee">
        <span class="text-black">{{ processingFeeLabel }}</span>
        <span class="font-normal text-black">{{ processingFee | formatPrice }}</span>
    </div>

    <div class="order-totals__row" *ngIf="showTaxableSubtotal">
        <span class="text-black">{{ taxableSubtotalLabel }}</span>
        <span class="font-normal text-black">{{ taxableSubtotal | formatPrice }}</span>
    </div>

    <div class="order-totals__row">
        <span class="text-black">{{ vatLabel }}</span>
        <span class="font-normal text-black">{{ vat | formatPrice }}</span>
    </div>

    <div class="order-totals__row order-totals__row--grand">
        <span [class]="variant === 'card' ? 'text-[16px] font-medium text-black' : 'text-[18px] font-medium text-black'">
            {{ totalLabel }}
        </span>
        <span [class]="variant === 'card' ? 'text-[18px] font-semibold text-black' : 'text-[22px] font-medium text-black'">
            {{ total | formatPrice }}
        </span>
    </div>
</div>
